import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Alert,
    Button,
    Spinner,
    Badge,
    ListGroup
} from 'react-bootstrap';
import { CompaniaManager } from "managers";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";

const QuickBooksRedirect = () => {
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [message, setMessage] = useState('');
    const [companyInfo, setCompanyInfo] = useState(null);
    const [authCode, setAuthCode] = useState('');
    const [realmId, setRealmId] = useState('');
    const logo = require("../../assets/img/quickbooks-brand-preferred-logo.png")
    const { Message, cerrarAlertas } = useMessage();
    const { handleException } = useExceptionHandler();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const companyId = urlParams.get('realmId');
        const launch = urlParams.get('launch');

        if (launch == 'true') {
            try {
                CompaniaManager.obtenerURLQuickbooks()
                    .then((res) => {
                        window.location.href = res.Data;
                    })
                    .catch((e) => {

                        handleException(e)
                    });

            } catch (error) {
                handleException(error)
            } finally {
            }

        }
        else if (code && companyId) {
            setAuthCode(code);
            setRealmId(companyId);
            handleQuickBooksCallback(code, companyId);
        } else {
            setStatus('error');
            setMessage('Parámetros de autorización faltantes');
        }
    }, []);

    const handleQuickBooksCallback = async (code, realmId) => {
        try {
            setStatus('loading');
            setMessage('Procesando autorización con QuickBooks...');

            // Aquí harías la llamada a tu backend para intercambiar el código por tokens

            await CompaniaManager.vincularCuentaQuickbooks({ code, realmId })
                .then((res) => {
                    Message({ message: `Cuenta Vinculada Exitosamente` });
                    const url = new URL(window.location.href);
                    url.search = '';
                    window.history.replaceState({}, document.title, url.toString());
                    setStatus('success');
                    setMessage('¡Integración con QuickBooks completada exitosamente!');

                })
                .catch((e) => {
                    setStatus('error');
                    setMessage(e.message);
                    handleException(e)
                });

        } catch (error) {
            console.error('Error en callback de QuickBooks:', error);
            setStatus('error');
            setMessage(error.message || 'Error al conectar con QuickBooks');
        }
    };

    const handleGoToDashboard = () => {
        window.location.href = '/dashboard';
    };

    const renderLoadingState = () => (
        <div className="text-center">
            <div className="mb-4">
                <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
            </div>
            <h3>Conectando con QuickBooks</h3>
            <p className="text-muted">{message}</p>
        </div>
    );

    const renderSuccessState = () => (
        <div className="text-center">
            {/* <div className="text-center mb-4">
                <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center  rounded-circle"
                    style={{ width: '64px', height: '64px' }}
                >
                    <i className="fas fa-check-circle text-success" style={{ fontSize: '64px' }}></i>
                </div>
            </div> */}
            <h3 className="text-success">¡Conexión Exitosa!</h3>
            <p className="text-muted mb-4">{message}</p>

            {companyInfo && (
                <Alert variant="success" className="mb-4">
                    <Alert.Heading className="h6">Información de la Empresa</Alert.Heading>
                    <ListGroup variant="flush">
                        <ListGroup.Item className="bg-transparent border-0 px-0">
                            <strong>Nombre:</strong> {companyInfo.name}
                        </ListGroup.Item>
                        <ListGroup.Item className="bg-transparent border-0 px-0">
                            <strong>ID:</strong> <Badge bg="secondary">{realmId}</Badge>
                        </ListGroup.Item>
                    </ListGroup>
                </Alert>
            )}
            <Button
                variant="primary"
                size="lg"
                onClick={handleGoToDashboard}
                className="w-100"
            >
                Ir al Dashboard
            </Button>
        </div>
    );

    const renderErrorState = () => (
        <div className="text-center">
            <h3 className="text-danger">Error Vinculando Compañia </h3>
            <p className="text-muted mb-4">{message}</p>

            <div className="d-grid gap-2">
                <Button
                    variant="outline-secondary"
                    onClick={handleGoToDashboard}
                >
                    <i className="fas fa-arrow-left me-2"></i>
                    Volver al Dashboard
                </Button>
            </div>
        </div>
    );

    return (
        <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={8} md={6} lg={4}>
                    <Card className="shadow-lg border-0">
                        <Card.Body className="p-5">
                            {/* Logo de QuickBooks */}
                            <div className="text-center mb-4">
                                <div
                                    className="mx-auto mb-3 d-flex align-items-center justify-content-center  rounded-circle"
                                    style={{ width: '14rem', height: 'auto' }}
                                >
                                    <img
                                        src={logo}
                                        alt="External Link"
                                        style={{ width: '14rem', height: 'auto' }}
                                    />
                                </div>
                            </div>

                            {/* Renderizado condicional basado en el estado */}
                            {status === 'loading' && renderLoadingState()}
                            {status === 'success' && renderSuccessState()}
                            {status === 'error' && renderErrorState()}
                        </Card.Body>

                        {/* Footer con información de seguridad */}
                        <Card.Footer className="bg-light border-0 text-center">
                            <small className="text-muted">
                                <div>Integración segura con QuickBooks Online</div>
                                <div>Todos los datos son transmitidos de forma encriptada</div>
                            </small>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default QuickBooksRedirect;